module.exports = __webpack_public_path__ + "static/img/banner-ngambisz.df36c38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-ngambisz.jpg
// module id = P7KP
// module chunks = 1